module.exports = __webpack_public_path__ + "static/audi-28dbd866da060efbebba1b1249c07fae.png";